module.exports = __webpack_public_path__ + "img/header-weddingRingsBudgetMedium.d69d416.webp";